import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetExamsProviderLocationAccredited,
	GetExamsProviderLocationAccreditedModel,
	GetExamsProviderLocationAccreditedParams,
} from 'domain/usecases/private/booking-flow/exams/get-exams-provider-location-accredited';

export class RemoteGetExamsProviderLocationAccredited implements GetExamsProviderLocationAccredited {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsProviderLocationAccreditedModel>,
	) {}

	async get({
		signal,
		...params
	}: GetExamsProviderLocationAccreditedParams): Promise<GetExamsProviderLocationAccreditedModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
